<script setup lang="ts">
import { useI18nResource } from '~/composables'

const module = import.meta.glob('../../resources/**/sales-terms.md', { eager: true })
const { component } = useI18nResource(module)
</script>

<template>
  <Component :is="component" />
</template>
